export default "__VITE_ASSET__WkrsgYaM__"